import React, { memo, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api from '../../../api'
import { ErrorModal } from '../../../components/Modal'
import CreateUserStyle from './CreateUserStyle'
import { useSelector } from 'react-redux'
import customMainApi from '../../../api'
import ClipLoader from 'react-spinners/ClipLoader'
import formatPhoneNumber from '../../../helpers/PhoneWithSpaces'
import { useTranslation } from 'react-i18next'
import { Button as AntButton, Empty } from 'antd'
import moment from 'moment'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		overflowX: 'auto',
		border: '1px solid #E5E7EB',
		boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
	},
}

const ViewIcloud = (props) => {
	const { getRef = () => {}, onUpdated = () => {}, onClose = () => {} } = props
	const { getMe } = useSelector((state) => state.main)
	const { t } = useTranslation()

	const errorRef = useRef()
	const [isOpenModal, setIsOpenModal] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [salesData, setSalesData] = useState([])

	useEffect(() => {
		const ref = {
			open: (data) => {
				setIsOpenModal(true)
				getSalesByIcloud(get(data, 'Name', ''))
			},
			close: () => {
				setIsOpenModal(false)
				setSalesData([])
				setIsLoading(false)
			},
		}
		getRef(ref)
	}, [])

	const getSalesByIcloud = (icloud) => {
		setIsLoading(true)
		customMainApi
			.get(
				`Invoices?$orderby=DocEntry desc&$select=DocNum,DocDate,CardName,CardCode,U_Icloud&$filter=DocumentStatus eq 'O' and Cancelled  eq 'N' and U_Icloud eq '${icloud}'`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=100',
					},
				},
			)
			.then((res) => {
				setSalesData(JSON.parse(res.data).value)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<CreateUserStyle>
				<div className="card">
					<p className="title">{'Список продаж'}</p>
					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-auto mb-8 mt-8 ">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className=" text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Номер документа
											</th>

											<th scope="col" className="px-6 py-4">
												Код Клиента
											</th>
											<th scope="col" className="px-6 py-4">
												Имя Клиента
											</th>
											<th scope="col" className="px-6 py-4">
												Дата продажи
											</th>
											<th scope="col" className="px-6 py-4">
												Аккаунт защиты
											</th>
										</tr>
									</thead>
									<tbody>
										{salesData.length > 0 ? (
											salesData.map((v, i) => (
												<tr
													className="bg-white border-b  hover:bg-gray-50 "
													key={i}
												>
													<td className="px-6 py-4">{get(v, 'DocNum', '')}</td>

													<td className="px-6 py-4 font-medium text-gray-900 ">
														{get(v, 'CardCode', '')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'CardName', '')}
													</td>
													<td className="px-6 py-4">
														{moment(get(v, 'DocDate')).format('DD.MM.YYYY')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'U_Icloud', '')}
													</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan="10">
													<Empty
														description={'Ничего не найдено'}
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</>
					)}
				</div>
			</CreateUserStyle>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
		</Modal>
	)
}

export default memo(ViewIcloud)
